<div class="surrender-page">
  <div class="notice">
    <div class="notice-body">
      If you have an offline surrender token from a Cristie Appliance, use the <a routerLink="/licenses"
        [queryParams]="{tab: 'offline-surrender'}" class="link">Offline Surrender</a> option instead.
    </div>
  </div>

  <div class="surrender-details-grid" [class.with-tokens]="showTokens" *ngIf="contract.returnsRemaining != 0 && contract.product != 'VA'">
    <mat-card>
      <mat-card-content>
        <app-license-details [contractDetails]="contract"></app-license-details>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="showTokens">
      <mat-card-content>
        <app-token-details [tokenDetails]="contract"></app-token-details>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="notice" *ngIf="success">
    <div class="notice-body">Surrender of licenses successful.</div>
  </div>

  <mat-card *ngIf="contract.returnsRemaining != 0" class="surrender-activation-card">
    <mat-card-content>
      <app-activation-details [loading]="loading" [activations]="activations" [showSurrender]="true" [showComments]="showComments"
        [returnsRemaining]="contract?.returnsRemaining" [rental]="contract.rental"
        (surrenderSelected)="surrenderLicenses()"></app-activation-details>
    </mat-card-content>
  </mat-card>

  <div class="notice notice-error" *ngIf="contract.returnsRemaining == 0">
    <div class="notice-body">
      You have no more surrenders remaining. Please contact <a [href]="mailtoLinkSurrender">support&#64;cristie.com</a>
      to increase your surrender count.
    </div>
  </div>
</div>

<ng-template #confirmSurrenderModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="confirm-surrender-dialog-title" class="dialog-title">
      <span class="title-text">Are you sure?</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="confirm-surrender-dismiss-button"
        (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      Are you sure you want to surrender {{ selectedActivations.length }} license<span *ngIf="selectedActivations.length !== 1">s</span>?
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-raised-button color="accent" type="button" id="confirm-surrender-cancel-button" (click)="closeDialog()">
        Cancel
      </button>
      <button mat-raised-button color="primary" type="button" id="confirm-surrender-confirm-button" (click)="confirmSurrender()"
        [disabled]="processing">
        <mat-spinner *ngIf="processing" diameter="20" mode="indeterminate"></mat-spinner>
        {{ processing ? 'Surrendering' : 'Confirm' }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #surrenderModal>
  <div class="mat-dialog-container">
    <h2 mat-dialog-title id="surrender-dialog-title" class="dialog-title">
      <span class="title-text">Surrender Licenses</span>
      <button mat-icon-button type="button" class="close-icon" aria-label="Close" id="surrender-dismiss-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content>
      <div class="surrender-processing" *ngIf="processing">
        <mat-spinner diameter="56"></mat-spinner>
        <p>Surrendering selected licenses...</p>
      </div>

      <div class="notice notice-error" *ngIf="failed">
        <div class="notice-body">
          <strong>Some licenses could not be surrendered.</strong>
          <ul>
            <li *ngFor="let item of removeFailed">
              {{ item.hostname }} {{ item.code }}
              <br>{{ error?.description }}
            </li>
          </ul>
        </div>
      </div>
      <div class="notice" *ngIf="success">
        <div class="notice-body">
          <strong>Licenses successfully returned.</strong>
          <ul>
            <li *ngFor="let item of removed">
              {{ item.hostname }} {{ item.code }}
            </li>
          </ul>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" type="button" id="surrender-modal-close-button" (click)="closeDialog()"
        [disabled]="processing">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
